var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#13348f",
    d: "M30 15 0 0v24h30l-18-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb2e40",
    d: "M1.36 23V2l24.22 12h-18l18 9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.28 12.64a3 3 0 0 0 3-3 3.2 3.2 0 0 1-1.35 1.59l-.26-.2.5-.37-.6-.16.32-.54-.63.09.1-.62-.55.32-.16-.61-.37.5-.38-.5-.16.6-.54-.31.1.62-.63-.09.32.54-.61.16.5.38-.25.19a3.2 3.2 0 0 1-1.35-1.59 3 3 0 0 0 3 3m1.97 6.3 1.25-.54-1.25-.52.81-1.08-1.34.16.17-1.34-1.09.81-.52-1.24-.53 1.24-1.08-.81.16 1.34-1.34-.16.81 1.08-1.24.52 1.24.53-.81 1.08 1.34-.16-.16 1.34 1.08-.81.53 1.24.52-1.24 1.09.81-.17-1.34 1.34.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/nepal.1f34a3c18a9bbc8ff7fcf0a981d751cd.svg";
export { ForwardRef as ReactComponent };